
<div class="input-group">
<button
  (click)="sectionPrev()"
  class="btn btn-secondary"><i class="fas fa-angle-left"></i>
</button>
<select class="form-select">
    <option *ngFor="let section of sections"
    [ngValue]="section.id"
    (click)="onSelect(section)"
    [selected]="selectedSection === section">{{ section.title }}</option>
</select>
<button
  (click)="sectionNext()"
  class="btn btn-secondary"><i class="fas fa-angle-right"></i>
</button>
</div>
<app-section [section]="selectedSection"></app-section>
<button
  (click)="goNext()"
  class="btn btn-primary float-end"
  i18n="Next">BUTTON_NEXT</button>
<button
  (click)="goPrevious()"
  class="btn btn-secondary"
  i18n="Previous">BUTTON_PREVIOUS</button>
